import {createApp} from 'vue'
import FrivilligeCheckoutContent from './FrivilligeCheckoutContent'

const el = '.kb-component--frivillige-checkout-content'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FrivilligeCheckoutContentDOM) => {
            const externalData = FrivilligeCheckoutContentDOM.dataset.external 
                ? JSON.parse(FrivilligeCheckoutContentDOM.dataset.external)
                : null
            const props = {
                userData: externalData?.userData ?? {},
            }
            const component = createApp(FrivilligeCheckoutContent, props).use(Store)
            component.mount(FrivilligeCheckoutContentDOM)
        })
    }
}